@if (campaignDetail().salesContent; as campaign) {
    @if (activeCar(); as currentCar) {
        <section>
            <ui-m060-c010-vehicle-showroom-wrapper
                [headline]="campaign.heroHeadline ?? ''"
                [subheadline]="dealerLocationHeadline()"
                [cars]="campaign.cars"
                [ctaLink]="'tel:' + dealer().phone"
                [ctaSubText]="dealer().phone"
                [ctaText]="currentCar.disableTestdrive ? 'Jetzt beraten lassen' : 'Jetzt Probefahrt vereinbaren'"
                [link]="currentCar.ctaFormUrl"
                [linkText]="currentCar.disableTestdrive ? 'Angebot anfragen' : 'Probefahrt vereinbaren'"
                [primaryButton]="currentCar.ctaFormUrl"
                [primaryButtonText]="currentCar.disableTestdrive ? 'Angebot anfragen' : 'Jetzt Probefahrt vereinbaren'"
                [showOnlyPrimaryButton]="showOnlyPrimaryButton()"
                [envkv]="{
                    model: currentCar.modelHeadline,
                    subheadline: currentCar.modelSubheadline,
                    envkv: currentCar.envkvDataSource?.envkv,
                    envkvText: currentCar.envkvText,
                    score:
                        (currentCar.envkvDataSource && currentCar.envkvDataSource.__typename === 'Model'
                            ? currentCar.envkvDataSource.co2ClassText
                            : currentCar.envkvDataSource?.co2Class) ?? '',
                }"
                (emitCurrentTabIndex)="changeCurrentTabIndex($event)"
                (primaryButtonClicked)="
                    tracking.trackButton({
                        elType: 'button',
                        event: 'engagement_click',
                        elLabel: 'Test Drive',
                        elTarget: currentCar.ctaFormUrl,
                    })
                "
                (linkClicked)="
                    tracking.trackButton({
                        elType: 'button',
                        event: 'engagement_click',
                        elLabel: 'Test Drive',
                        elTarget: currentCar.ctaFormUrl,
                    })
                "
                (ctaClicked)="
                    tracking.trackButton({
                        elType: 'button',
                        event: 'engagement_click',
                        elLabel: 'Test Drive',
                        elTarget: 'tel:' + dealer().phone,
                    })
                "
                isFirstView
            />
        </section>

        @if (currentCar.leasingExample) {
            <section class="flex justify-center bg-grey-100">
                <ui-m060-c020-vehicle-leasing-example
                    class="block w-full"
                    [headline]="currentCar.leasingHeadline ?? campaign.heroHeadline ?? ''"
                    [imageCaption]="campaign.heroImageCaption"
                    [nationalPricesDisclaimer]="
                        currentCar.nationalPricesDisclaimer && !currentCar.individualData
                            ? currentCar.nationalPricesDisclaimer
                            : undefined
                    "
                    [image]="campaign.heroImage"
                    [text]="currentCar.leasingExample.tableCopy"
                    [tableHeadline]="currentCar.leasingExample.tableHeadline"
                    [tableHeadlineValue]="currentCar.leasingExample.tableHeadlineValue"
                    [tableData]="currentCar.leasingExample.tableData"
                    [link]="currentCar.offerFormUrl"
                    [envkv]="{
                        model: currentCar.modelHeadline,
                        subheadline: currentCar.modelSubheadline,
                        envkv: currentCar.envkvDataSource?.envkv,
                        score:
                            (currentCar.envkvDataSource && currentCar.envkvDataSource.__typename === 'Model'
                                ? currentCar.envkvDataSource.co2ClassText
                                : currentCar.envkvDataSource?.co2Class) ?? '',
                        envkvText: currentCar.envkvText,
                    }"
                    [isFirstView]="true"
                    [priceBadge]="currentCar.priceBadge"
                    (linkClicked)="
                        tracking.trackButton({
                            elType: 'button',
                            event: 'engagement_click',
                            elLabel: 'Offer Quote Request',
                            elTarget: currentCar.offerFormUrl,
                        })
                    "
                    linkText="Angebot erhalten"
                />
            </section>
        }
    }

    <lib-similar-vehicles [similarVehicles]="campaign.teaserVehicles" title="Top Angebote aus unserem Sortiment">
        <a
            class="button-primary mx-auto mt-[88px] w-max"
            [hyundaiRouterLink]="dealer().pages.vehiclemarket"
            [queryParams]="queryParams()"
            link
        >
            Zum Fahrzeugbestand
        </a>
    </lib-similar-vehicles>

    @if (campaignCars().length > 0) {
        <section>
            @for (car of campaignCars(); track $index) {
                <ui-m060-c030-vehicle-teaser
                    [text]="car.contentCopy ?? ''"
                    [ctaLink]="'tel:' + dealer().phone"
                    [ctaSubText]="dealer().phone"
                    [ctaText]="car.disableTestdrive ? 'Jetzt beraten lassen' : 'Jetzt Probefahrt vereinbaren'"
                    [link]="car.ctaFormUrl"
                    [linkText]="car.disableTestdrive ? 'Angebot anfragen' : 'Probefahrt vereinbaren'"
                    [shortInfos]="car.shortInfos"
                    [image]="car.contentImage || { url: '' }"
                    [imageCaption]="car.contentImageCaption"
                    [showOnlyPrimaryButton]="showOnlyPrimaryButton()"
                    [isFirstView]="$index === 1"
                    [envkv]="car.envkv"
                    [disableEnvkv]="car.disableEnvkvDataTeaser ?? false"
                    (primaryButtonClicked)="
                        tracking.trackButton({
                            elType: 'button',
                            event: 'engagement_click',
                            elLabel: 'Test Drive',
                            elTarget: car.ctaFormUrl,
                        })
                    "
                    (linkClicked)="
                        tracking.trackButton({
                            elType: 'button',
                            event: 'engagement_click',
                            elLabel: 'Test Drive',
                            elTarget: car.ctaFormUrl,
                        })
                    "
                    (ctaClicked)="
                        tracking.trackButton({
                            elType: 'button',
                            event: 'engagement_click',
                            elLabel: 'Test Drive',
                            elTarget: 'tel:' + dealer().phone,
                        })
                    "
                >
                    <h2 headline>{{ car.contentHeadline ?? '' }}</h2>
                </ui-m060-c030-vehicle-teaser>
            }
        </section>
    }

    @defer {
        <section>
            <app-global-contact isFirstView="false" />
        </section>

        @if (campaign.warrantyLogo1 || campaign.warrantyLogo2 || campaign.warrantyLogo3) {
            <section>
                <ui-m040-c015-warrenty-footer-logos
                    [logos]="[campaign.warrantyLogo1, campaign.warrantyLogo2, campaign.warrantyLogo3]"
                />
            </section>
        }

        @if (campaign.legalLines) {
            <section>
                <ui-m040-c020-rte [data]="campaign.legalLines" />
            </section>
        }
    }
}
